<template>
  <GuidesCard
    :guide-item="styleItem"
    :coming-soon="comingSoon"
    @submit="$emit('submit', $event)"
  >
    <template #guide-card-content>
      <div class="description">
        {{ styleItem.description }}
      </div>
      <div class="style-rules">
        <div
          v-for="(phrase, index) in parsedPhrases"
          :key="index"
          class="style-rule"
        >
          <template
            v-for="{ text, color, key } of phrase"
            :key="key"
          >
            <span
              :class="['rule-text', color ? `rule-${styleItem.color}` : '']"
            >{{ text }}</span>
          </template>
          <div />
        </div>
      </div>
    </template>
  </GuidesCard>
</template>

<script setup>
import { computed } from 'vue';
import GuidesCard from '@/components/settings/components/GuidesCard.vue';

const props = defineProps({
  styleItem: {
    type: Object,
    default: () => ({}),
  },
  comingSoon: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['submit']);

const parsedPhrases = computed(() => props.styleItem.phrases.map(
  (phrase) => phrase.split(/(\[.*?)\]/).map((text) => ({
    text: text.replace(/\[/g, ''),
    color: text[0] === '[',
  })),
));
</script>

<style scoped lang="less">
  each(@severitySetSolid, .(@color, @severity-class) {
    .rule-@{severity-class} {
      background-color: fade(@color, 20%);
    }
  })

  each(@severitySetUnderline, .(@color, @severity-class) {
    .rule-@{severity-class} {
      border-bottom: 1px solid fade(@color, 60%);
    }
  })
  .style-form {
  width: calc(50% - 6px);
  margin-top: 12px;
  background-color: @white;
  border-radius: 10px;
    .v-switch.v-input--density-compact {
      --v-input-control-height: 20px;

      :deep(.v-selection-control__wrapper) {
        height: auto;
      }
    }

    .v-input.v-switch {
      line-height: 1;
    }
  }

  .style-rules {
  margin-top: 8px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  padding: 0;
  }

  .description {
    font-size: 14px;
    font-weight: 300;
  }

  .style-rule {
  display: inline-block;
  align-self: flex-start;
  margin-top: 8px;
  }

  .rule-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 27px;
  }

  p.rule-text {
    display: inline-block;
    width: auto;
  }
</style>
